// extracted by mini-css-extract-plugin
export default {"logo":"HomePage_logo__4I9zw","buttons":"HomePage_buttons__D+gYl"};